module.exports = __webpack_public_path__ + "img/logo.c32befb6.svg";